"use client"

import { useState } from "react"
import { Info } from "lucide-react"
import { Popover, PopoverContent, PopoverTrigger } from "@/shared/components/ui/popover"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/shared/components/ui/tooltip"
import { cn } from "@/shared/lib/utils"

const NO_EMAIL_INFO_HEADING = "No Email Available option"
const NO_EMAIL_INFO_TEXT =
  "Choose 'No Email Available' when no email exists. Admin/Base Leader can update the email later when a valid email is available. Group Leader can update the email later when a valid Group Volunteer email is available. Without a valid email, the Homeowner/Volunteer cannot log in to ReliefHub to view or update their information."

type NoEmailInfoIconProps = {
  className?: string
}

export default function NoEmailInfoIcon({ className }: NoEmailInfoIconProps) {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <button
                type="button"
                className={cn("inline-flex h-5 w-5 items-center justify-center text-muted-foreground hover:text-foreground", className)}
                aria-label="No email information"
              >
                <Info className="h-4 w-4" />
              </button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="max-w-[320px] text-xs">
            <p className="font-medium mb-1">{NO_EMAIL_INFO_HEADING}</p>
            <p>{NO_EMAIL_INFO_TEXT}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <PopoverContent side="bottom" className="max-w-[340px] text-sm">
        <p className="font-medium mb-1">{NO_EMAIL_INFO_HEADING}</p>
        <p>{NO_EMAIL_INFO_TEXT}</p>
      </PopoverContent>
    </Popover>
  )
}
